<section>
  <ng-container *ngIf="shopType === userShopType.WooCommerceShop; else ShopifyAndDefaultCoupons">
    <pf-woo-commerce-coupon
      [isOverlay]="isOverlay"
      (closeOverlay)="closeOverlay.emit($event)">
    </pf-woo-commerce-coupon>
  </ng-container>
  <ng-template #ShopifyAndDefaultCoupons>
    <div class="L-CouponCode">
      <div class="L-CouponCode-Content Card">
        <h4 *ngIf="!isEditMode" class="L-CouponCode-Content-Title">{{ 'coupon_form.create_title' | transloco }}</h4>

        <form
          class="CouponCode-Form"
          [class._is-edit]="isEditMode"
          [formGroup]="formGroup"
          pfScrollInvalidInput
          [labelOffset]="100"
          #formRef>
          <h5 class="CouponCode-Form-Subtitle"
          >
            {{ 'coupon_form.label_title' | transloco }}
            <span class="Tooltip mt-1 mr-auto"
                  [matTooltip]="'coupon_form.title_tooltip' | transloco"
                  matTooltipClass="Tooltip-Box" matTooltipPosition="above"
            ></span>
          </h5>

          <div class="PluginConfig-Line">
            <input type="text" class="form-control" formControlName="title"
                   [placeholder]="'coupon_form.title_placeholder' | transloco">
            <div class="invalid-feedback">
              {{ 'coupon_form.err_title_required' | transloco }}
            </div>
          </div>

        <h5 class="CouponCode-Form-Subtitle">{{ 'coupon_form.label_code' | transloco }}</h5>
        <div class="CouponCode-Config">
          <div *ngIf="!isEditMode">
            <label>{{ 'coupon_form.label_type' | transloco }}</label>
            <div class="CouponCode-Radio">
              <!--template for Shopify-->
              <ng-container *ngIf="shopType === userShopType.ShopifyShop">
                <div *ngIf="!onlyStaticCodeAllowed" class="CouponCode-Radio-Item _is-recommended">
                  <input type="radio" formControlName="type" id="{{'radio' + couponCodeType.shopify_unique}}"
                         [value]="couponCodeType.shopify_unique">
                  <label for="{{'radio' + couponCodeType.shopify_unique}}">
                    <span class="checkmark"></span>
                    {{ 'coupon_form.radio_unique_code' | transloco }}
                    <span class="_recommended-tip">{{ 'coupon_form.recommended' | transloco }}</span>
                    <small>{{ 'coupon_form.small_custom_one_time' | transloco }}</small>
                  </label>
                </div>
                <div class="CouponCode-Radio-Item">
                  <input type="radio" formControlName="type" id="{{'radio' + couponCodeType.shopify_master}}"
                         [value]="couponCodeType.shopify_master">
                  <label for="{{'radio' + couponCodeType.shopify_master}}">
                    <span class="checkmark"></span>
                    {{ 'coupon_form.radio_generic_code' | transloco }}
                    <small>{{ 'coupon_form.small_same_all' | transloco }}</small>
                  </label>
                </div>
              </ng-container>

              <!--template for BigCommerce-->
              <ng-container *ngIf="shopType === userShopType.BigCommerceShop">
                <div *ngIf="!onlyStaticCodeAllowed" class="CouponCode-Radio-Item _is-recommended">
                  <input type="radio" formControlName="type" id="{{'radio' + couponCodeType.big_commerce_unique}}"
                         [value]="couponCodeType.big_commerce_unique">
                  <label for="{{'radio' + couponCodeType.big_commerce_unique}}">
                    <span class="checkmark"></span>
                    {{ 'coupon_form.radio_unique_code' | transloco }}
                    <span class="_recommended-tip">{{ 'coupon_form.recommended' | transloco }}</span>
                    <small>{{ 'coupon_form.small_custom_one_time' | transloco }}</small>
                  </label>
                </div>
                <div class="CouponCode-Radio-Item">
                  <input type="radio" formControlName="type" id="{{'radio' + couponCodeType.big_commerce_master}}"
                         [value]="couponCodeType.big_commerce_master">
                  <label for="{{'radio' + couponCodeType.big_commerce_master}}">
                    <span class="checkmark"></span>
                    {{ 'coupon_form.radio_generic_coupon' | transloco }}
                    <small>{{ 'coupon_form.small_same_all' | transloco }}</small>
                  </label>
                </div>
              </ng-container>

              <div class="CouponCode-Radio-Item" *ngIf="![userShopType.ShopifyShop, userShopType.BigCommerceShop].includes(shopType)">
                <input type="radio" formControlName="type" id="{{'radio' + couponCodeType.manual_master}}"
                       [value]="couponCodeType.manual_master">
                <label for="{{'radio' + couponCodeType.manual_master}}">
                  {{ 'coupon_form.radio_manual_coupon' | transloco }}
                  <small>{{ 'coupon_form.small_same_all' | transloco }}</small>
                </label>
              </div>
            </div>
          </div>

          <div class="PluginConfig-Line" *ngIf="isEditMode">
            <label>{{ 'coupon_form.label_type' | transloco }}</label>
            <div class="CouponCode-Radio _is-edit">
              <div class="CouponCode-Radio-Item">
                <ng-container [ngSwitch]="true" *ngIf="formGroup.getRawValue().type as Type">
                  <label *ngSwitchCase="[couponCodeType.shopify_master, couponCodeType.big_commerce_master].includes(Type)">
                    {{ 'coupon_form.edit_generic_coupon' | transloco }}
                  </label>
                  <label *ngSwitchCase="Type === couponCodeType.manual_master">
                    {{ 'coupon_form.edit_manual_coupon' | transloco }}
                  </label>
                  <label *ngSwitchCase="[couponCodeType.shopify_unique, couponCodeType.big_commerce_unique].includes(Type)">
                    {{ 'coupon_form.edit_unique_coupon' | transloco }}
                  </label>
                  <label *ngSwitchCase="Type === couponCodeType.manual_unique">
                    {{ 'coupon_form.edit_manual_coupon' | transloco }}
                  </label>
                </ng-container>
              </div>
            </div>
          </div>

          <ng-container [ngSwitch]="true" *ngIf="formGroup.getRawValue().type as Type">

            <div *ngSwitchCase="[couponCodeType.shopify_master, couponCodeType.big_commerce_master].includes(Type)" class="PluginConfig-Line">
              <label class="d-flex justify-content-between">
                {{ 'coupon_form.label_coupon_code' | transloco }}
                <span class="Tooltip mt-1 ml-1 mr-auto"
                      [matTooltip]="'coupon_form.tooltip_all_checkout' | transloco"
                      matTooltipClass="Tooltip-Box" matTooltipPosition="above"
                ></span>
              </label>
              <div class="CouponCode-Generator">
                <input type="text" class="form-control _local-code-input" formControlName="master_code" maxlength="255"
                       [placeholder]="'coupon_form.placeholder_enter_code' | transloco"
                       #masterCodeInput>
                <a *ngIf="!isEditMode" href="#" (click)="generateCode($event, 'master_code')">{{ 'coupon_form.generate_code' | transloco }}</a>
                <ng-container *ngIf="formGroup.get('master_code').errors; let errors">
                  <div class="invalid-feedback" *ngIf="errors.required">
                    {{ 'coupon_form.err_code_required' | transloco }}
                  </div>
                  <div class="invalid-feedback" *ngIf="errors.maxlength">
                    {{ 'coupon_form.err_code_max_50' | transloco }}
                  </div>
                </ng-container>
              </div>
            </div>

            <ng-container *ngSwitchCase="[couponCodeType.shopify_unique, couponCodeType.big_commerce_unique].includes(Type)">
              <div class="PluginConfig-Line">
                <label class="d-flex justify-content-between">
                  {{ 'coupon_form.label_prefix_optional' | transloco }}
                  <span class="Tooltip mt-1 ml-1 mr-auto"
                        [matTooltip]="'coupon_form.tooltip_prefix' | transloco"
                        matTooltipClass="Tooltip-Box" matTooltipPosition="above"
                  ></span>
                </label>
                <div class="CouponCode-Prefix" >
                  <input type="text" class="form-control" formControlName="prefix_code" maxlength="16"
                         [placeholder]="'coupon_form.prefix_placeholder' | transloco">
                  <div class="CouponCode-Prefix-Code-Example">
                    <span *ngIf="summary">{{summary.randomString}}</span>
                  </div>
                </div>
                <small class="CouponCode-Tip">{{ 'coupon_form.tip_keep_short' | transloco }}</small>
              </div>

              <div class="PluginConfig-Line" formGroupName="data">
                <label class="d-flex justify-content-between">
                  {{ 'coupon_form.label_code_length' | transloco }}
                </label>
                <div>
                  <input type="number" min="6" max="16" class="form-control _small mt-3" [positiveIntegers]="true"
                         (click)="onNumberInputClick($event)"
                         (focusout)="onCodeLengthChange($event)"
                         (focus)="touchControl('coupon_code_length')" formControlName="coupon_code_length">
                </div>
                <small class="CouponCode-Tip">
                  {{ 'coupon_form.tip_random_suffix' | transloco: { n: formGroup.getRawValue().data.coupon_code_length } }}
                </small>
                <div class="invalid-feedback">
                  {{ 'coupon_form.err_code_length_range' | transloco }}
                </div>
              </div>

            </ng-container>
            <!-- <ng-container *ngIf="!isEditMode">
              <div class="CouponCode-Manual-Code-Separator">
                <span>OR</span>
              </div>
              <div class="CouponCode-Radio-Item">
                <input type="radio" formControlName="type" id="{{'radio' + couponCodeType.manual_master}}"
                       [value]="couponCodeType.manual_master">
                <label for="{{'radio' + couponCodeType.manual_master}}">
                  <span class="checkmark"></span>
                  Use Manual Code
                </label>
              </div>
            </ng-container> -->
            <div *ngSwitchCase="Type === couponCodeType.manual_master" class="PluginConfig-Line">
              <label class="d-flex justify-content-between">
                {{ 'coupon_form.label_coupon_code' | transloco }}
                <span class="Tooltip mt-1 ml-1 mr-auto"
                      [matTooltip]="(isEditMode ? ('coupon_form.tooltip_manual_checkout' | transloco) : ('coupon_form.existing_code_hint' | transloco))"
                      matTooltipClass="Tooltip-Box" matTooltipPosition="above"
                ></span>
              </label>
              <div class="CouponCode-Generator">
                <input type="text" class="form-control _local-code-input" formControlName="master_code" maxlength="255"
                       [placeholder]="'coupon_form.placeholder_enter_code' | transloco">
                <a *ngIf="!isEditMode" href="#" (click)="generateCode($event, 'master_code')">{{ 'coupon_form.generate_code' | transloco }}</a>
                <ng-container *ngIf="formGroup.get('master_code').errors; let errors">
                  <div class="invalid-feedback" *ngIf="errors.required">
                    {{ 'coupon_form.err_code_required' | transloco }}
                  </div>
                  <div class="invalid-feedback" *ngIf="errors.maxlength">
                    {{ 'coupon_form.err_code_max_50' | transloco }}
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>

          <!-- [data] -->
          <ng-container formGroupName="data">
            <ng-container *ngIf="formGroup.getRawValue().type === couponCodeType.shopify_master || formGroup.getRawValue().type === couponCodeType.big_commerce_master">
              <h5 class="CouponCode-Form-Subtitle">{{ 'coupon_form.section_usage_limits' | transloco }}</h5>

              <div class="PluginConfig-Line py-0">
                <label class="PluginConfig-Control-Label _black _with-switch-fw" formGroupName="_local">
                  {{ 'coupon_form.limit_total_uses' | transloco }}
                  <pf-switch-box
                    [labelInside]="true"
                    [labelOff]="'coupon_form.switch_off' | transloco"
                    formControlName="setUsageLimit">
                  </pf-switch-box>
                </label>

                <div class="form-group mt-3" [class.is-hidden]="!formGroup.getRawValue().data._local.setUsageLimit">
                  <div class="input-group">
                    <input type="number" min="0" max="99999999" step="1" formControlName="usage_limit" class="form-control"
                          (focus)="touchControl('usage_limit')"
                           (click)="onNumberInputClick($event)"
                           (focusout)="onValueChange('usage_limit', $event, 99999999, 0)">
                    <div class="invalid-feedback">
                      {{ 'coupon_form.err_value_range_usage' | transloco }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="PluginConfig-Line py-0">
                <label class="PluginConfig-Control-Label _black _with-switch-fw">
                  {{ 'coupon_form.limit_once_customer' | transloco }}
                  <pf-switch-box
                    [labelInside]="true"
                    [labelOff]="'coupon_form.switch_off' | transloco"
                    formControlName="once_per_customer">
                  </pf-switch-box>
                </label>
              </div>

              <!-- Discount Combinations (Shopify generic coupons) - disabled in edit mode since changes won't affect already issued codes -->
              <div class="PluginConfig-Line py-0" *ngIf="shopType === userShopType.ShopifyShop">
                <label class="PluginConfig-Control-Label _black _with-switch-fw">
                  {{ 'coupon_form.allow_combine_discounts' | transloco }}
                  <span class="Tooltip mt-1 ml-1 mr-auto"
                        [matTooltip]="'coupon_form.tooltip_combine' | transloco"
                        matTooltipClass="Tooltip-Box" matTooltipPosition="above"
                  ></span>
                  <pf-switch-box
                    [labelInside]="true"
                    [labelOff]="'coupon_form.switch_off' | transloco"
                    [disabled]="isEditMode"
                    [ngModel]="formGroup.getRawValue().data.combines_with_product_discounts"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onCombinesWithDiscountsChange($event)">
                  </pf-switch-box>
                </label>
              </div>
            </ng-container>

            <!-- Behavior -->
            <div [class.is-hidden]="formGroup.getRawValue().type !== couponCodeType.shopify_unique && formGroup.getRawValue().type !== couponCodeType.big_commerce_unique">
              <h5 class="CouponCode-Form-Subtitle">{{ 'coupon_form.section_behavior' | transloco }}</h5>

              <!-- Discount Combinations (Shopify only) - disabled in edit mode since changes won't affect already issued codes -->
              <div class="PluginConfig-Line py-0" *ngIf="shopType === userShopType.ShopifyShop">
                <label class="PluginConfig-Control-Label _black _with-switch-fw">
                  {{ 'coupon_form.allow_combine_discounts' | transloco }}
                  <span class="Tooltip mt-1 ml-1 mr-auto"
                        [matTooltip]="'coupon_form.tooltip_combine' | transloco"
                        matTooltipClass="Tooltip-Box" matTooltipPosition="above"
                  ></span>
                  <pf-switch-box
                    [labelInside]="true"
                    [labelOff]="'coupon_form.switch_off' | transloco"
                    [disabled]="isEditMode"
                    [ngModel]="formGroup.getRawValue().data.combines_with_product_discounts"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onCombinesWithDiscountsChange($event)">
                  </pf-switch-box>
                </label>
              </div>

              <div class="PluginConfig-Line">
                <label class="PluginConfig-Control-Label _black _with-switch-fw">
                  {{ 'coupon_form.expires_after_toggle' | transloco }}
                  <pf-switch-box
                    [labelInside]="true"
                    [labelOff]="'coupon_form.switch_off' | transloco"
                    formControlName="expires_after_enabled">
                  </pf-switch-box>
                </label>

                <!--
                <div class="text-danger Expires-validity"
                     [class._invalid]="formGroup.controls['data'].hasError('expiresError')">
                  All fields can't be zero
                </div>
                -->

                <div class="form-inline" [class.is-hidden]="!formGroup.getRawValue().data.expires_after_enabled">
                  <label class="mr-3">{{ 'coupon_form.label_expires_after' | transloco }}</label>
                  <ng-container *ngIf="!isEditMode">
                    <div class="config-control _double _local-behavior-options">
                      <input
                        [class.is-invalid]="
                          formGroup.get('data.expires_after_years').errors ||
                          formGroup.get('data.expires_after_days').errors ||
                          formGroup.get('data.expires_after_hours').errors ||
                          formGroup.get('data.expires_after_minutes').errors"
                        type="number"
                        #timeInput
                        [value]="selectedTime"
                        step="1"
                        min="1"
                        placeholder="0"
                        class="form-control  _medium"
                        (focus)="onTimeFocus(selectedUnit)"
                        (click)="onNumberInputClick($event)"
                        (focusout)="onTimeChange(selectedUnit, $any($event.target).value)">
                        <mat-form-field class="pf-form-field ml-2">
                          <mat-select [(value)]="selectedUnit" class="form-control _large" (selectionChange)="onUnitChange(selectedUnit)">
                            <mat-option *ngFor="let option of unitOptionDefs" [value]="option.value">
                              {{ option.labelKey | transloco }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                    </div>
                    <br>
                    <div class="error-text">
                      <small class="text-danger mb-1" *ngIf="formGroup.get('data.expires_after_years').errors?.max">
                        {{ 'coupon_form.err_expires_max' | transloco }}
                      </small>
                      <small class="text-danger mb-1" *ngIf="formGroup.get('data.expires_after_years').errors?.min">
                        {{ 'coupon_form.err_expires_min' | transloco }}
                      </small>
                      <small class="text-danger mb-1" *ngIf="formGroup.get('data.expires_after_days').errors?.max">
                        {{ 'coupon_form.err_expires_max' | transloco }}
                      </small>
                      <small class="text-danger mb-1" *ngIf="formGroup.get('data.expires_after_days').errors?.min">
                        {{ 'coupon_form.err_expires_min' | transloco }}
                      </small>
                      <small class="text-danger mb-1" *ngIf="formGroup.get('data.expires_after_hours').errors?.max">
                        {{ 'coupon_form.err_expires_max' | transloco }}
                      </small>
                      <small class="text-danger mb-1" *ngIf="formGroup.get('data.expires_after_hours').errors?.min">
                        {{ 'coupon_form.err_expires_min' | transloco }}
                      </small>
                      <small class="text-danger mb-1" *ngIf="formGroup.get('data.expires_after_minutes').errors?.max">
                        {{ 'coupon_form.err_expires_max' | transloco }}
                      </small>
                      <small class="text-danger mb-1" *ngIf="formGroup.get('data.expires_after_minutes').errors?.min">
                        {{ 'coupon_form.err_expires_min' | transloco }}
                      </small>
                      <small class="text-danger mb-1" *ngIf="formGroup.get('data.expires_after_minutes').errors?.empty">
                        {{ 'coupon_form.err_expires_empty' | transloco }}
                      </small>
                    </div>

                    <input type="hidden" class="form-control" formControlName="expires_after_years">
                    <input type="hidden" class="form-control" formControlName="expires_after_days">
                    <input type="hidden" class="form-control" formControlName="expires_after_hours">
                    <input type="hidden" class="form-control" formControlName="expires_after_minutes">
                  </ng-container>

                  <ng-container *ngIf="isEditMode">
                    <div [hidden]="showOldStyle" class="config-control _double">
                      <input type="number" [value]="editValue" class="form-control _medium" disabled>
                      <mat-form-field class="pf-form-field ml-2">
                        <mat-select [(value)]="editOption" class="form-control _large disabled" disabled="true">
                          <mat-option *ngFor="let option of unitOptionDefs" [value]="option.value">
                            {{ option.labelKey | transloco }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div [hidden]="!showOldStyle" class="form-inline">
                      <input type="number" class="form-control _small" formControlName="expires_after_years">
                      <label class="ml-3 mr-3">{{ 'coupon_form.unit_years' | transloco }}</label>
                      <input type="number" class="form-control _small" formControlName="expires_after_days">
                      <label class="ml-3 mr-3">{{ 'coupon_form.unit_days' | transloco }}</label>
                      <input type="number" class="form-control _small" formControlName="expires_after_hours">
                      <label class="ml-3 mr-3">{{ 'coupon_form.unit_hours' | transloco }}</label>
                      <input type="number" class="form-control _small" formControlName="expires_after_minutes">
                      <label class="ml-3">{{ 'coupon_form.unit_minutes' | transloco }}</label>
                    </div>
                  </ng-container>
                </div>

              </div>
            </div>
          </ng-container>
          <!-- [ end of data] -->

          <div
            [class.is-hidden]="formGroup.getRawValue().type === couponCodeType.manual_master || formGroup.getRawValue().type === couponCodeType.manual_unique">
            <h5 class="CouponCode-Form-Subtitle">{{ 'coupon_form.section_discount_rules' | transloco }}</h5>
            <!-- [data] -->
            <div class="CouponCode-Config">
            <ng-container formGroupName="data">
              <input type="hidden" formControlName="value_type">
              <input type="hidden" formControlName="target_type">
              <div class="PluginConfig-Line" formGroupName="_local">
                <label>{{ 'coupon_form.label_discount_type' | transloco }}</label>
                <select class="form-control" #discountType formControlName="discountType"
                        (change)="updateValueType($event)">
                  <option [value]="couponCodeValueType.fixed_amount">{{ 'coupon_form.opt_fixed_amount' | transloco }}</option>
                  <option [value]="couponCodeValueType.percentage">{{ 'coupon_form.opt_percentage' | transloco }}</option>
                  <option [value]="couponCodeTargetType.shipping_line">{{ 'coupon_form.opt_free_shipping' | transloco }}</option>
                  <option [value]="couponCodeValueType.buy_x_get_y" *ngIf="this.shopType !== userShopType.BigCommerceShop">{{ 'coupon_form.opt_buy_x_get_y' | transloco }}</option>
                </select>
              </div>

              <ng-container *ngIf="discountType.value !== couponCodeTargetType.shipping_line">
                <ng-container [ngSwitch]="discountType.value">
                  <div class="PluginConfig-Line" *ngSwitchCase="couponCodeValueType.fixed_amount">
                    <label>{{ 'coupon_form.label_discount_value' | transloco }}</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{currency}}</span>
                      </div>
                      <input type="number" min="0" class="form-control" formControlName="value">
                      <div class="invalid-feedback">
                        {{ 'coupon_form.err_value_gt_zero' | transloco }}
                      </div>
                    </div>
                  </div>
                  <div class="PluginConfig-Line" *ngSwitchCase="couponCodeValueType.percentage">
                    <label>{{ 'coupon_form.label_discount_percent' | transloco }}</label>
                    <div class="input-group">
                      <input type="number" min="0" max="100" class="form-control border-right-0" formControlName="value"
                             (click)="onNumberInputClick($event)"
                             (keydown)="touchControl('value')"
                             (focusout)="onValueChange('value', $event, 100, 1)">
                      <div class="input-group-append">
                        <span class="input-group-text">%</span>
                      </div>
                      <div class="invalid-feedback">
                        {{ 'coupon_form.err_percent_range' | transloco }}
                      </div>
                    </div>
                  </div>

                  <ng-container *ngSwitchCase="couponCodeValueType.buy_x_get_y">
                    <div class="PluginConfig-Line">
                      <h5 class="mb-0">{{ 'coupon_form.heading_customer_buys' | transloco }}</h5>
                    </div>
                    <div class="PluginConfig-Line" formGroupName="_local">
                      <label class="radio">
                        <input type="radio"
                               [value]="uiCouponMinimumRequirements.quantity"
                               (change)="updateMinimumRequirements()"
                               *ngIf="this.shopType !== userShopType.BigCommerceShop"
                               formControlName="minimumRequirements"> {{ 'coupon_form.radio_min_qty' | transloco }}
                      </label>
                      <br>
                      <label class="radio mb-0">
                        <input type="radio"
                               [value]="uiCouponMinimumRequirements.price"
                               (change)="updateMinimumRequirements()"
                               formControlName="minimumRequirements"> {{ 'coupon_form.radio_min_purchase' | transloco }}
                      </label>
                    </div>

                    <pf-coupon-code-products
                      controlName="buysTargetSelection"
                      [productSelectorType]="uiProductSelectorType.buys"
                      [label]="('coupon_form.label_any_items_from' | transloco)"
                      [minimumOption]="formGroup.getRawValue().data._local.minimumRequirements"
                      [formGroup]="formGroup"
                      [isEditMode]="isEditMode"
                      [productsListService]="buyProductsListService"
                      (updateTargetSelectionChange)="updateTargetSelection($event)"
                      (showProductSelectorClick)="showProductSelector($event, uiProductSelectorType.buys)"
                    ></pf-coupon-code-products>

                    <div class="PluginConfig-Line">
                      <h5 class="mb-0">{{ 'coupon_form.heading_customer_gets' | transloco }}</h5>
                    </div>

                    <pf-coupon-code-products
                      controlName="getsTargetSelection"
                      [productSelectorType]="uiProductSelectorType.gets"
                      [label]="('coupon_form.label_any_items_from' | transloco)"
                      [formGroup]="formGroup"
                      [isEditMode]="isEditMode"
                      [productsListService]="getProductsListService"
                      (updateTargetSelectionChange)="updateTargetSelection($event)"
                      (showProductSelectorClick)="showProductSelector($event, uiProductSelectorType.gets)"
                    ></pf-coupon-code-products>

                    <div class="PluginConfig-Line" formGroupName="_local">
                      <label class="PluginConfig-Control-Label _black _with-switch-fw">
                        {{ 'coupon_form.max_uses_per_order' | transloco }}
                        <pf-switch-box
                          [labelInside]="true"
                          [labelOff]="'coupon_form.switch_off' | transloco"
                          #maxUsesNumberEnabled
                          (change)="onMaxUsesNumberEnabled($event)"
                          formControlName="maxUsesNumberEnabled">
                        </pf-switch-box>
                      </label>
                    </div>

                    <div class="PluginConfig-Line form-inline" [class.is-hidden]="!$any(maxUsesNumberEnabled).value">
                      <label class="d-flex justify-content-between">
                        {{ 'coupon_form.label_num_uses' | transloco }}
                      </label>
                      <input
                        type="number"
                        step="1" min="1" max="2147483647"
                        class="form-control ml-3"
                        (click)="onNumberInputClick($event)"
                        (focus)="touchControl('usage_per_order')"
                        (focusout)="onValueChange('usage_per_order', $event, 2147483647, 1)"
                        formControlName="usage_per_order">
                      <div class="invalid-feedback">
                        {{ 'coupon_form.err_valid_value' | transloco }}
                      </div>
                      <!-- <input type="text" class="form-control" formControlName="usage_per_order"> -->
                    </div>

                    <div class="PluginConfig-Line">
                      <h5 class="mb-0">{{ 'coupon_form.heading_discounted_value' | transloco }}</h5>
                    </div>

                    <div class="PluginConfig-Line" formGroupName="_local">
                      <label class="radio mb-0">
                        <input type="radio"
                               [value]="uiDiscountValue.free"
                               (change)="updateDiscountValue(100)"
                               formControlName="discountValue"> {{ 'coupon_form.opt_free' | transloco }}
                      </label>
                      <br>
                      <label class="radio">
                        <input type="radio"
                               [value]="uiDiscountValue.percentage"
                               (change)="updateDiscountValue(0)"
                               formControlName="discountValue"> {{ 'coupon_form.opt_percentage_short' | transloco }}
                      </label>

                      <div
                        class="input-group"
                        style="max-width: 250px;"
                        *ngIf="formGroup.getRawValue().data._local.discountValue === uiDiscountValue.percentage">
                        <input
                          type="number"
                          min="0"
                          max="100"
                          step="1"
                          class="form-control"
                          formControlName="buyXgetYDiscount"
                          (input)="updateDiscountValue($any($event.target).value)">
                        <div class="input-group-append">
                          <span class="input-group-text">%</span>
                        </div>
                      </div>
                    </div>

                  </ng-container>

                </ng-container>

                <input type="hidden" formControlName="target_selection">

                <input type="hidden" formControlName="allocation_method">
                <div class="PluginConfig-Line" [class.is-hidden]="discountType.value !== couponCodeValueType.fixed_amount ||
                 formGroup.getRawValue().data._local.defaultTargetSelection === uiCouponTargetSelection.all">
                  <label class="PluginConfig-Control-Label _black _with-switch-fw mt-1" formGroupName="_local">
                    <span>{{ 'coupon_form.apply_once_per_order' | transloco }}</span>
                    <pf-switch-box [labelOff]="'coupon_form.switch_off' | transloco" formControlName="allocationMethod"
                                   (change)="updateAllocationMethod()" [labelInside]="true">
                    </pf-switch-box>
                  </label>
                  <small>{{ 'coupon_form.help_allocation' | transloco }}</small>
                </div>

                <pf-coupon-code-products
                  *ngIf="productsListByShopType"
                  controlName="defaultTargetSelection"
                  [productSelectorType]="productsListByShopType"
                  [class.is-hidden]="formGroup.getRawValue().data._local.discountType === couponCodeValueType.buy_x_get_y"
                  [label]="('coupon_form.label_applies_to' | transloco)"
                  [formGroup]="formGroup"
                  [isEditMode]="isEditMode"
                  [productsListService]="defaultProductsListService"
                  (updateTargetSelectionChange)="updateTargetSelection($event)"
                  (showProductSelectorClick)="showProductSelector($event, uiProductSelectorType.default)"
                ></pf-coupon-code-products>

              </ng-container>

              <div class="PluginConfig-Line"
                   [class.is-hidden]="formGroup.getRawValue().data.target_type !== couponCodeTargetType.shipping_line">
                <label class="mb-0">{{ 'coupon_form.label_shipping_rates' | transloco }}</label>
                <label class="PluginConfig-Control-Label _black _with-switch-fw mt-1" formGroupName="_local">
                  <span>{{ 'coupon_form.exclude_shipping_over' | transloco }}</span>
                  <pf-switch-box [labelOff]="'coupon_form.switch_off' | transloco" formControlName="shippingRates"
                                 (change)="updateShippingRates()" [labelInside]="true">
                  </pf-switch-box>
                </label>
                <div class="form-group mt-3" [class.is-hidden]="!formGroup.getRawValue().data._local.shippingRates">
                  <input type="number" min="0" class="form-control" formControlName="prerequisite_shipping_price_max" [positiveIntegers]="true">
                  <div class="invalid-feedback visible" *ngIf="formGroup.get('data.prerequisite_shipping_price_max').hasError('min')">
                    {{ 'coupon_form.err_value_gt_zero' | transloco }}
                  </div>
                  <div class="invalid-feedback visible" *ngIf="formGroup.get('data.prerequisite_shipping_price_max').hasError('max')">
                    {{ 'coupon_form.err_valid_value' | transloco }}
                  </div>
                </div>
              </div>

              <div class="PluginConfig-Line" [class.is-hidden]="discountType.value === couponCodeValueType.buy_x_get_y">
                <ng-container formGroupName="_local">
                  <label>{{ 'coupon_form.label_min_requirements' | transloco }}</label>
                  <select class="form-control" formControlName="minimumRequirements" #minimumRequirements
                          (change)="updateMinimumRequirements()">
                    <option [value]="uiCouponMinimumRequirements.none">{{ 'coupon_form.opt_none' | transloco }}</option>
                    <option [value]="uiCouponMinimumRequirements.price">{{ 'coupon_form.radio_min_purchase' | transloco }}</option>
                    <option [value]="uiCouponMinimumRequirements.quantity" *ngIf="this.shopType !== userShopType.BigCommerceShop">{{ 'coupon_form.radio_min_qty' | transloco }}</option>
                  </select>
                </ng-container>

                <div class="form-inline mt-3" [ngSwitch]="minimumRequirements.value"
                     [class.is-hidden]="minimumRequirements.value === uiCouponMinimumRequirements.none">
                  <ng-container *ngSwitchCase="uiCouponMinimumRequirements.price">
                    <label class="mr-3">{{ 'coupon_form.radio_min_purchase' | transloco }}</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{currency}}</span>
                      </div>
                      <input type="number" min="0" class="form-control" formControlName="prerequisite_subtotal_min"
                             (click)="onNumberInputClick($event)"
                             (focus)="touchControl('prerequisite_subtotal_min')"
                             (focusout)="onValueChange('prerequisite_subtotal_min', $event, maxSafeInt, 0, false)">
                    </div>
                    <div class="invalid-feedback visible" *ngIf="formGroup.get('data.prerequisite_subtotal_min').hasError('min')">
                      {{ 'coupon_form.err_value_gt_zero' | transloco }}
                    </div>
                    <div class="invalid-feedback visible" *ngIf="formGroup.get('data.prerequisite_subtotal_min').hasError('max')">
                      {{ 'coupon_form.err_valid_value' | transloco }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="uiCouponMinimumRequirements.quantity">
                    <label>{{ 'coupon_form.radio_min_qty' | transloco }}</label>
                    <input type="number" min="0" max="99999999" step="1" class="form-control ml-3"
                           formControlName="prerequisite_quantity_range_min"
                           (click)="onNumberInputClick($event)"
                           (focus)="touchControl('prerequisite_quantity_range_min')"
                           (focusout)="onValueChange('prerequisite_quantity_range_min', $event, 99999999)">
                    <div class="invalid-feedback">
                      {{ 'coupon_form.err_value_range_usage' | transloco }}
                    </div>
                  </ng-container>
                </div>
              </div>

            </ng-container>
            </div>

            <!-- [ end of data] -->
          </div>
        </form>
      </div>

      <div class="L-CouponCode-Aside">
        <div class="CouponCode-Summary">
          <div class="text-dark" *ngIf="summary">

            <!-- Schedule -->
            <!-- <p>{{summary.schedule.start}}</p>
            <p *ngIf="summary.schedule.end">{{summary.schedule.end}}</p> -->

            <!-- Code Type -->
            <!-- <p>{{summary.codeType}}</p> -->

            <!-- Code -->
            <div class="CouponCode-Code">
              <ng-container [ngSwitch]="true" *ngIf="formGroup.getRawValue().type as Type">
                <ng-container *ngSwitchCase="Type === couponCodeType.manual_master">
                  <h5>{{ 'coupon_form.preview_master' | transloco }}</h5>
                  <small class="text-danger" *ngIf="!formGroup.pristine && summary.code">
                    {{ 'coupon_form.preview_valid_after_save' | transloco }}
                  </small>
                  <pre>{{summary.code}} </pre>
                </ng-container>
                <ng-container *ngSwitchCase="[couponCodeType.shopify_master, couponCodeType.big_commerce_master].includes(Type)">
                  <h5>{{ 'coupon_form.preview_master' | transloco }}</h5>
                  <small class="text-danger" *ngIf="!formGroup.pristine && summary.code">
                    {{ 'coupon_form.preview_valid_after_save' | transloco }}
                  </small>
                  <pre>{{summary.code}} </pre>
                </ng-container>
                <ng-container *ngSwitchCase="Type === couponCodeType.manual_unique">
                  <h5>{{ 'coupon_form.preview_unique' | transloco }}</h5>
                  <small class="CouponCode-Code-Warning-Text">
                    {{ 'coupon_form.preview_sample_popup' | transloco }}
                  </small>
                  <pre>{{summary.code}} </pre>
                </ng-container>
                <ng-container *ngSwitchCase="[couponCodeType.shopify_unique, couponCodeType.big_commerce_unique].includes(Type)">
                  <h5>{{ 'coupon_form.preview_unique' | transloco }}</h5>
                  <small class="CouponCode-Code-Warning-Text">
                    {{ 'coupon_form.preview_sample_popup' | transloco }}
                  </small>
                  <pre>{{summary.code}} </pre>
                </ng-container>
              </ng-container>
            </div>

            <ul>
              <!-- Discount -->
              <li *ngIf="summary.discount">{{summary.discount}} {{summary.discoutnRelatedTo}}</li>
              <!-- Limit -->
              <li *ngIf="summary.limit">{{summary.limit}}</li>
            </ul>

            <div class="d-flex justify-content-around mt-4">
              <button class="pf-button md outline gray" (click)="cancel()">{{ 'coupon_form.btn_cancel' | transloco }}</button>
              <button class="pf-button md filled blue" (click)="submit()">{{ 'coupon_form.btn_save' | transloco }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</section>



<pf-loading-overlay [filter]="{only: ['new-coupon-code']}" class="loading-overlay"></pf-loading-overlay>
